import React from 'react';
import { observer } from 'mobx-react-lite';
import { decorateName } from '@unmapped/core/utils';
import useFilteredResults from '@unmapped/core/hooks/useFilteredResults';
import useComponentOverride from "../../hooks/useComponentOverride.js";
import useStyleOverride from "../../hooks/useStyleOverride.js";
import baseStyles from "./styles.module.css.js";
export var ResultsList = decorateName(observer(_ref => {
  var {
    onResultClick
  } = _ref;
  var results = useFilteredResults();
  var [ResultItem, NoResults] = useComponentOverride('results/ResultItem', 'results/NoResults');
  var styles = useStyleOverride('results/ResultsList', baseStyles);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.ResultsList
  }, results.length ? results.map(result => /*#__PURE__*/React.createElement(ResultItem, {
    result: result,
    key: result.id,
    onClick: onResultClick ? e => onResultClick(result, e) : undefined
  })) : /*#__PURE__*/React.createElement(NoResults, null));
}), 'ResultsList');
export default ResultsList;
//# sourceMappingURL=index.js.map